<template>
  <div>
    <h4>Настройки</h4>
    <div class="razd"></div>
    <label>
      <span class="l_title">Режим игры</span>
      <Select2 v-model="params.mode" :options="modes" :settings="{multiple: false,minimumResultsForSearch: -1}" />
    </label>
    <div class="razd"></div>
    <label>
      <span class="l_title">Расположение</span>
      <Select2 v-model="params.orientation" :options="orient" :settings="{multiple: false,minimumResultsForSearch: -1}" />
    </label>
    <div class="razd"></div>
    <label v-if="params.mode === 'words'">
      <span class="l_title">Слова из {{ params.letters_count }} букв</span>
      <input type="range" class="uk-range" v-model="params.letters_count" min="4" max="8" step="2">
    </label>
    <label v-if="params.mode === 'digits'">
      <span class="l_title">Размер чисел: {{ params.digits_count }}</span>
      <input type="range" class="uk-range" v-model="params.digits_count" min="1" max="6" step="1">
    </label>
    <div class="razd"></div>
    <label >
      <span class="l_title">Количество строк: {{ params.rows }}</span>
      <input type="range" class="uk-range" v-model="params.rows" min="5" max="20" step="1">
    </label>
    <!--<label class="check_label">
      <input type="checkbox" class="uk-checkbox" v-model="params.has_accent">
      <span>Акценты</span>
    </label>-->
    <!--<label class="check_label">
      <input type="checkbox" class="uk-checkbox" v-model="params.show_reactions">
      <span>Анимации</span>
    </label>-->
  </div>
</template>

<script>
import Select2 from 'v-select2-component';

export default {
  name: "settings",
  components: { Select2 },
  watch: {
    params: {
      handler: function (newValue) {
        if (!this.ingame) {
          this.$emit('params_changed', this.params);
        }
      },
      deep: true
    },
  },
  data() {
    return {
      module_name: 'wedge',
      modes: [
        {
          id: 'words',
          text: 'Слова'
        },
        {
          id: 'digits',
          text: 'Цифры'
        },
      ],
      type: [
        {
          id: 'train',
          text: 'Тренировка'
        },
      ],
      orient: [
        {
          id: 'row',
          text: 'Горизонтальная'
        },
        {
          id: 'column',
          text: 'Вертикальная'
        },
      ],
      params: ''
    }
  },
  props: {
    is_homework: ''
  },
  computed: {
    role() {
      return this.$store.state.user.role.code;
    },
  },
  mounted() {
    this.params = this.$store.state.train[this.module_name + '_params'];
  }
}
</script>